import MathBlockNodeView from './MathBlockNodeView';

export default class MathInlineNodeView extends MathBlockNodeView {
    constructor(node, view, getPos) {
        super(node, view, getPos);
    }

    get displayNode() {
        return false;
    }

    createDom() {
        return document.createElement('span');
    }
}